var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99998 0.740723C4.89443 0.740723 0.740723 4.89443 0.740723 9.99998C0.740723 15.1055 4.89443 19.2592 9.99998 19.2592C15.1055 19.2592 19.2592 15.1055 19.2592 9.99998C19.2592 4.89443 15.1055 0.740723 9.99998 0.740723ZM9.99998 17.4074C5.91572 17.4074 2.59257 14.0842 2.59257 9.99998C2.59257 5.91572 5.91572 2.59257 9.99998 2.59257C14.0842 2.59257 17.4074 5.91572 17.4074 9.99998C17.4074 14.0842 14.0842 17.4074 9.99998 17.4074Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9258 5.37061H9.07397V10.3836L12.123 13.4326L13.4323 12.1234L10.9258 9.6169V5.37061Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/time.f9204a6dba0469e63fee6321e6fa8daa.svg";
export { ForwardRef as ReactComponent };